import styled from 'styled-components';

export const Container = styled.div`
  background-color: var(--background);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;

  overflow-x: hidden;
`;
